<template>
  <div v-if="dataResponse != null">
    <v-select
      id="register-orderStatus"
      v-model="orderStatus"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      label="name"
      :clearable="false"
      :placeholder="`${$t('Change')}${$t('Order Status')}`"
      :options="optionOrderStatus"
      :reduce="optionOrderStatus => optionOrderStatus.value"
      @input="changeStatus($event)"
    />
    <b-list-group class="mb-2">
      <b-list-group-item>
        {{ this.$t('OrderCode') }} :
        {{ subStringOrderId(dataResponse.orderCode) }}
      </b-list-group-item>
      <b-list-group-item>
        {{ this.$t('OrderId') }} :
        {{ subStringOrderId(dataResponse._id).toUpperCase() }}
      </b-list-group-item>

      <b-list-group-item v-if="dataResponse.priceShipment">
        <b-row class="align-items-center">
          <b-col>
            {{ this.$t('Shipping cost') }}
          </b-col>
          <b-col>
            <div class="d-flex align-items-center">

              <cleave
                id="register-priceShipment"
                v-model="priceShipment"
                class="form-control w-full"
                :raw="false"
                :options="optionCleave.number"
                :placeholder="$t('Shipping cost')"
              />
              <b-button

                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="ml-1"
                :variant="'success'"
                size="sm"
                @click="saveShippingPrice"
              >
                {{ $t('Save Shipping cost') }}
                <feather-icon
                  icon="ShoppingBagIcon"
                  size="12"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.priceCod > 0">
        {{ this.$t('Destination delivery fee') }} :
        {{ (dataResponse.priceCod / 100) | numberWithCommas }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.coupon.price > 0">
        {{ this.$t('Coupon') }} :
        {{ (dataResponse.coupon.price / 100) | numberWithCommas }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.sale > 0">
        {{ this.$t('Price to pay') }} :
        {{
          (dataResponse.currencyId === null
            ? dataResponse.sale / 100
            : (dataResponse.sale_currency / 100).toFixed(2)) | numberWithCommas
        }}{{ dataResponse.currencySymbol }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.pointSum > 0">
        {{ this.$t('Points received') }} :
        {{ (dataResponse.pointSum / 100) | numberWithCommas }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.pv > 0">
        {{ this.$t('PV') }} :
        {{ (dataResponse.pv) | numberWithCommas }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.creditSum > 0">
        {{ this.$t('Commission for referrals') }} :
        {{ (dataResponse.creditSum / 100) | numberWithCommas }}
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.coupon">
        <b-row class="align-items-center">
          <b-col>
            {{ this.$t('Coupon') }} : {{ showFromCurrentLanguage(dataResponse.coupon.name) }}
          </b-col>
          <b-col>
            <v-select
              id="register-orderStatus"
              v-model="couponId"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :clearable="true"
              :placeholder="`${$t('Change')}${$t('Coupon')}`"
              :options="respDataCoupon"
              :reduce="respDataCoupon => respDataCoupon._id"
              @input="changeCoupon($event)"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item v-if="dataResponse.branch">
        <b-row class="align-items-center">
          <b-col>
            {{ this.$t('Branch') }} : {{ showFromCurrentLanguage(dataResponse.branch.name) }}
          </b-col>
          <b-col>
            <v-select
              id="register-orderStatus"
              v-model="branchId"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="name"
              :clearable="true"
              :placeholder="`${$t('Change')}${$t('Branch')}`"
              :options="respDataBranch"
              :reduce="respDataBranch => respDataBranch._id"
              @input="changeBranch($event)"
            />
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
    <div
      v-if="dataResponse != null"
      class="mb-2"
    >
      <b-button
        v-if="editAddressStatus === false"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'warning'"
        size="sm"
        @click="editAddressStatus = !editAddressStatus"
      >
        {{ $t('Edit address') }}
        <feather-icon
          icon="ShoppingBagIcon"
          size="12"
        />
      </b-button>
      <b-button
        v-if="editAddressStatus === true"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'success'"
        size="sm"
        @click="saveAddress"
      >
        {{ $t('Save address') }}
        <feather-icon
          icon="ShoppingBagIcon"
          size="12"
        />
      </b-button>
    </div>
    <b-media
      vertical-align="top"
      class="mb-2"
    >
      <h4 class="media-heading">
        {{ $t('Recipient') }} : {{ dataResponse['address']['name'] }}
      </h4>
      <div v-if="editAddressStatus === true">
        <b-row>
          <b-col cols="12">
            <b-form-group
              :label="$t('Address')"
              label-for="register-Address"
            >
              <b-form-input
                id="register-Address"
                v-model="address"
                name="register-Address"
                :placeholder="$t('Address')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('Country')"
              label-for="register-countryId"
            >
              <v-select
                id="register-countryId"
                v-model="countryId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :clearable="false"
                :placeholder="$t('Country')"
                :options="OptionCountry"
                :reduce="OptionCountry => OptionCountry"
                @input="getProvince($event)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('State')"
              label-for="register-countryId"
            >
              <v-select
                id="register-stateId"
                v-model="stateId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :clearable="false"
                :placeholder="$t('State')"
                :options="OptionState"
                :reduce="OptionState => OptionState"
                @input="getDistrict($event)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('City')"
              label-for="register-cityId"
            >
              <v-select
                id="register-cityId"
                v-model="cityId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :clearable="false"
                :placeholder="$t('City')"
                :options="OptionCity"
                :reduce="OptionCity => OptionCity"
                @input="getSubDistrict($event)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group
              :label="$t('Sub City')"
              label-for="register-subCityId"
            >
              <v-select
                id="register-subCityId"
                v-model="subCityId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :clearable="false"
                :placeholder="$t('Sub City')"
                :options="OptionSubCity"
                :reduce="OptionSubCity => OptionSubCity"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              :label="$t('Phone Number')"
              label-for="register-phoneNumber"
            >
              <b-form-input
                id="register-phoneNumber"
                v-model="tel"
                name="register-phoneNumber"
                :placeholder="$t('Phone Number')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              :label="$t('ZipCode')"
              label-for="register-ZipCode"
            >
              <b-form-input
                id="register-ZipCode"
                v-model="zipCode"
                name="register-ZipCode"
                :placeholder="$t('ZipCode')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-card-text
          v-if="dataResponse.address.countryId === null || dataResponse.address.countryId.id === 219"
          class="mb-0"
        >
          {{ $t('Phone Number') }} : {{ dataResponse.address.tel }},
          {{ $t('Address') }} : {{ dataResponse.address.address }},
          {{
            dataResponse.address.subdistrictId != null
              ? `${$t('Subdistrict')} ${showFromCurrentLanguage(
                dataResponse.address.subdistrictId.name,
              )}, `
              : ''
          }}
          {{
            dataResponse.address.districtId != null
              ? `${$t('District')} ${showFromCurrentLanguage(
                dataResponse.address.districtId.name,
              )}, `
              : ''
          }}
          {{
            dataResponse.address.provinceId != null
              ? `${$t('Province')} ${showFromCurrentLanguage(
                dataResponse.address.provinceId.name,
              )}, `
              : ''
          }}
          {{ dataResponse.address.zipCode }}
        </b-card-text>
        <b-card-text
          v-else
          class="mb-0"
        >
          {{ $t('Phone Number') }} : {{ dataResponse.address.tel }},
          {{ $t('Address') }} : {{ dataResponse.address.address }},
          {{
            dataResponse.address.subCityId != null
              ? `${showFromCurrentLanguage(
                dataResponse.address.subCityId.name,
              )}, `
              : ''
          }}
          {{
            dataResponse.address.cityId != null
              ? `${showFromCurrentLanguage(
                dataResponse.address.cityId.name,
              )}, `
              : ''
          }}
          {{
            dataResponse.address.stateId != null
              ? `${showFromCurrentLanguage(
                dataResponse.address.stateId.name,
              )}, `
              : ''
          }}
          {{
            dataResponse.address.countryId != null
              ? `${dataResponse.address.countryId.name}, `
              : ''
          }}
          {{ dataResponse.address.zipCode }}
        </b-card-text>
      </div>
    </b-media>
    <div
      v-if="dataResponse != null"
      class="float-right mb-2"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        size="sm"
        class="mr-2"
        @click="openAddProductModal"
      >
        <feather-icon
          icon="PlusIcon"
          size="12"
          class="mr-25"
        />
        {{ $t('Add product') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        size="sm"
        class="mr-2"
        @click="editStatus = !editStatus"
      >
        {{ $t('Price to pay') }} : {{ priceToPay | numberWithCommas }}
        {{ dataResponse.currencySymbol }}
      </b-button>
      <!-- 
        Chat button to open chat with the member and send OrderId message.
        This button navigates to the chat page with the user ID and automatically
        sends a message containing the order information for context.
        The button label and tooltip are localized for multi-language support.
      -->
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="info"
        size="sm"
        class="mr-2"
        :title="$t('Chat with member')"
        @click="openChatWithMember"
      >
        <feather-icon
          icon="MessageCircleIcon"
          size="12"
        />
        {{ $t('Chat') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="success"
        size="sm"
        class="mr-2"
        @click="sendOrderToWhatsapp"
      >
        {{ $t('Send to WhatsApp') }}
        <feather-icon
          icon="SendIcon"
          size="12"
        />
      </b-button>
      <b-button
        v-if="editStatus === false"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'warning'"
        size="sm"
        @click="editStatus = !editStatus"
      >
        {{ $t('Edit order') }}
        <feather-icon
          icon="ShoppingBagIcon"
          size="12"
        />
      </b-button>
      <b-button
        v-if="editStatus === true"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        :variant="'success'"
        size="sm"
        @click="saveOrder"
      >
        {{ $t('Save order') }}
        <feather-icon
          icon="ShoppingBagIcon"
          size="12"
        />
      </b-button>
    </div>
    <b-table
      ref="refUserListTable"
      striped
      responsive
      class="position-relative"
      :items="products"
      :fields="tableColumns"
      primary-key="_id"
      show-empty
      :empty-text="$t('No matching records found')"
    >
      <template #cell(_id)="data">
        <b-card-text>{{ data.index + 1 }}</b-card-text>
      </template>

      <template #cell(image)="data">
        <b-row>
          <b-img
            v-if="data.item.product.images.length > 0"
            :src="data.item.product.images[0]"
            fluid
            thumbnail
            width="100px"
            :alt="'Users_' + data.item._id"
          />
          <b-img
            v-else
            :src="require('@/assets/images/blank/no_image.png')"
            fluid
            thumbnail
            width="100px"
            :alt="'Users_' + data.item._id"
          />
        </b-row>
      </template>

      <template #cell(option)="data">
        <b-card-text>{{ nameOption(data.item.productOptionId) }}</b-card-text>
      </template>

      <template #cell(price)="data">
        <template v-if="editStatus === false">
          <b-card-text v-if="dataResponse.currencyId === null">{{
            (data.item.price / 100) | numberWithCommas
          }}</b-card-text>

          <b-card-text v-else>{{ (data.item.price_currency / 100).toFixed(2) | numberWithCommas
          }}{{ dataResponse.currencySymbol }}</b-card-text>
        </template>
        <cleave
          v-if="editStatus === true"
          :value="(data.item.price / 100).toFixed(2)"
          class="form-control w-full"
          :raw="false"
          :options="optionCleave.number"
          :placeholder="$t('Price')"
          @input="val => { data.item.price = Math.round(parseFloat(val.toString().replace(/,/g, '')) * 100) || 0 }"
        />
      </template>

      <template #cell(product)="data">
        <b-card-text>{{
          data.item.product.optionNameTranslate === 'multiple'
            ? showFromCurrentLanguage(data.item.product.nameTranslate)
            : data.item.product.name
        }}</b-card-text>
      </template>

      <template #cell(amount)="data">
        <b-card-text v-if="editStatus === false">{{
          data.item.amount
        }}</b-card-text>
        <cleave
          v-if="editStatus === true"
          id="register-amount"
          v-model="data.item.amount"
          class="form-control w-full"
          :raw="false"
          :options="optionCleave.number"
          :placeholder="$t('Amount')"
        />
      </template>

      <template #cell(action)="data">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="danger"
          size="sm"
          @click="deleteData(data.item._id)"
        >
          <feather-icon icon="TrashIcon" />
        </b-button>
      </template>

      <template #cell(total)="data">
        <b-card-text>{{
          totalProduct(data.item) | numberWithCommas
        }}</b-card-text>
      </template>
    </b-table>

    <!-- Modal for adding products to order -->
    <b-modal
      id="modal-add-product-order"
      v-model="isAddProductModalActive"
      :title="$t('Add product to order')"
      size="lg"
      hide-footer
      centered
    >
      <b-overlay
        :show="productSearchLoading"
        rounded="sm"
      >
        <b-row class="mb-2">
          <b-col cols="12">
            <b-input-group>
              <b-form-input
                v-model="searchProductQuery"
                :placeholder="$t('Search product name') + '...'"
                @input="debouncedSearchProducts"
                @keyup.enter="searchProducts"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click="searchProducts"
                >
                  <feather-icon icon="SearchIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>

        <div
          v-if="searchProductList.length === 0"
          class="text-center my-3 text-muted"
        >
          {{ $t('No matching records found') }}
        </div>

        <div
          v-else
          class="table-responsive"
          style="max-height: 400px;"
        >
          <b-table
            small
            striped
            hover
            :items="searchProductList"
            :fields="productModalColumns"
          >
            <template #cell(images)="data">
              <b-img
                v-if="data.item.images && data.item.images.length > 0"
                :src="data.item.images[0]"
                fluid
                thumbnail
                width="60px"
              />
              <b-img
                v-else
                :src="require('@/assets/images/blank/no_image.png')"
                fluid
                thumbnail
                width="60px"
              />
            </template>

            <template #cell(name)="data">
              <div>
                <strong>{{ data.item.optionNameTranslate === 'multiple' ? showFromCurrentLanguage(data.item.nameTranslate) : data.item.name }}</strong>
                <div
                  v-if="data.item.discount > 0"
                  class="text-danger small"
                >
                  {{ $t('Discount') }}: {{ data.item.discount }}%
                </div>
              </div>
            </template>

            <template #cell(price)="data">
              <span>{{ (data.item.price / 100) | numberWithCommas }} {{ dataResponse.currencySymbol }}</span>
            </template>

            <template #cell(options)="data">
              <v-select
                v-if="data.item.productOptions && data.item.productOptions.length > 0"
                v-model="selectedOptionsMap[data.item._id]"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :options="data.item.productOptions"
                :placeholder="$t('Select option')"
                size="sm"
              />
              <span
                v-else
                class="text-muted small"
              >-</span>
            </template>

            <template #cell(quantity)="data">
              <b-form-input
                v-model.number="selectedQuantityMap[data.item._id]"
                type="number"
                min="1"
                size="sm"
                style="width: 70px;"
              />
            </template>

            <template #cell(action)="data">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                size="sm"
                @click="addProductToOrder(data.item)"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="12"
                />
                {{ $t('Add to order') }}
              </b-button>
            </template>
          </b-table>
        </div>

        <div
          v-if="searchProductMax > perPageProductSearch"
          class="d-flex justify-content-between align-items-center mt-2"
        >
          <span class="text-muted small">
            {{ currentPageProductSearch * perPageProductSearch - (perPageProductSearch - 1) }} -
            {{ currentPageProductSearch * perPageProductSearch > searchProductMax ? searchProductMax : currentPageProductSearch * perPageProductSearch }}
            {{ $t('of') }} {{ searchProductMax }}
          </span>
          <b-pagination
            v-model="currentPageProductSearch"
            :total-rows="searchProductMax"
            :per-page="perPageProductSearch"
            size="sm"
            class="mb-0"
            @input="onSearchPageChange"
          />
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCardText,
  BFormCheckbox,
  BButton,
  BImg,
  BMedia,
  BTable,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormInput,
  BModal,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BOverlay,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import debounce from 'debounce'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

const STORE_MODULE_NAME_COUPON = 'coupon'
const STORE_MODULE_NAME_BRANCH = 'branch'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    // eslint-disable-next-line vue/no-unused-components
    BCol,
    // eslint-disable-next-line vue/no-unused-components
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    BImg,
    BMedia,
    BTable,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    BFormInput,
    BModal,
    BInputGroup,
    BInputGroupAppend,
    BPagination,
    BOverlay,
    Cleave,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'dataResponse',
    event: 'update:data-response',
  },
  props: {
    storeModuleName: {
      type: String,
      required: true,
    },
    dataResponse: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      optionCleave: {
        number: {
          numeral: true,
        },
      },
      dataId: null,
      products: [],
      countryId: null,
      stateId: null,
      cityId: null,
      subCityId: null,
      orderStatus: '',
      zipCode: '',
      tel: '',
      address: '',
      editStatus: false,
      editAddressStatus: false,
      couponId: null,
      branchId: null,
      priceShipment: '',
      isAddProductModalActive: false,
      productSearchLoading: false,
      searchProductQuery: '',
      searchProductList: [],
      searchProductMax: 0,
      currentPageProductSearch: 1,
      perPageProductSearch: 10,
      selectedQuantityMap: {},
      selectedOptionsMap: {},
    }
  },
  computed: {
    OptionCountry() {
      return (
        store.state[this.storeModuleName].respDataCountry.map(e => ({
          _id: e._id,
          id: e.id,
          name: e.name,
        })) || []
      )
    },
    OptionState() {
      return (
        store.state[this.storeModuleName].respDataState.map(e => {
          const indexLang = e.name.findIndex(
            name => name.lang === this.$i18n.locale,
          )
          if (indexLang > -1) {
            return {
              _id: e._id,
              id: e.id,
              name: e.name[indexLang].value,
            }
          }
          return {
            _id: e._id,
            id: e.id,
            name: e.name[0].value,
          }
        }) || []
      )
    },
    OptionCity() {
      return (
        store.state[this.storeModuleName].respDataCity.map(e => {
          const indexLang = e.name.findIndex(
            name => name.lang === this.$i18n.locale,
          )
          if (indexLang > -1) {
            return {
              _id: e._id,
              id: e.id,
              name: e.name[indexLang].value,
            }
          }
          return {
            _id: e._id,
            id: e.id,
            name: e.name[0].value,
          }
        }) || []
      )
    },
    OptionSubCity() {
      return (
        store.state[this.storeModuleName].respDataSubCity.map(e => {
          const indexLang = e.name.findIndex(
            name => name.lang === this.$i18n.locale,
          )
          if (indexLang > -1) {
            return {
              _id: e._id,
              id: e.id,
              name: e.name[indexLang].value,
            }
          }
          return {
            _id: e._id,
            id: e.id,
            name: e.name[0].value,
          }
        }) || []
      )
    },
    productModalColumns() {
      return [
        { key: 'images', label: this.$t('Image'), sortable: false },
        { key: 'name', label: this.$t('Product name'), sortable: false },
        { key: 'price', label: this.$t('Price'), sortable: false },
        { key: 'options', label: this.$t('Option'), sortable: false },
        { key: 'quantity', label: this.$t('Quantity'), sortable: false },
        { key: 'action', label: this.$t('ACTION'), sortable: false },
      ]
    },
    priceToPay() {
      let price = 0
      for (let i = 0; i < this.products.length; i += 1) {
        const item = this.products[i]
        const amount = parseFloat(item.amount.toString().replaceAll(',', '')) || 0
        if (this.dataResponse.currencyId === null) {
          const itemPrice = item.price || 0
          const discount = item.discount || 0
          const salePrice = itemPrice - (itemPrice * (discount / 100))
          price += salePrice * amount
        } else {
          const itemPrice = item.price_currency || item.price || 0
          const discount = item.discount_currency || item.discount || 0
          const salePrice = itemPrice - (itemPrice * (discount / 100))
          price += salePrice * amount
        }
      }
      const shippingCost = (this.priceShipment !== '' && this.priceShipment !== null && this.priceShipment !== undefined)
        ? parseFloat(this.priceShipment.toString().replaceAll(',', '')) * 100
        : (this.dataResponse.priceShipment || 0)
      const couponPrice = (this.dataResponse.coupon && this.dataResponse.coupon.price) ? this.dataResponse.coupon.price : 0
      const pointsDiscount = this.dataResponse.pointsDiscount || 0
      const creditUsed = this.dataResponse.creditUsed || 0

      const netPrice = Math.max(0, price + shippingCost - couponPrice - pointsDiscount - creditUsed)
      return (netPrice / 100).toFixed(2)
    },
    optionOrderStatus() {
      return [
        {
          name: this.$t('waiting_to_check_the_order'.toUpperCase()),
          value: 'waiting_to_check_the_order',
        },
        {
          name: this.$t('to_be_paid'.toUpperCase()),
          value: 'to_be_paid',
        },
        {
          name: this.$t('pending_review'.toUpperCase()),
          value: 'pending_review',
        },
        {
          name: this.$t('to_be_shipped'.toUpperCase()),
          value: 'to_be_shipped',
        },
        {
          name: this.$t('something_to_get'.toUpperCase()),
          value: 'something_to_get',
        },
        {
          name: this.$t('success'.toUpperCase()),
          value: 'success',
        },
        {
          name: this.$t('cancel'.toUpperCase()),
          value: 'cancel',
        },
        {
          name: this.$t('refund'.toUpperCase()),
          value: 'refund',
        },
        {
          name: this.$t('fail'.toUpperCase()),
          value: 'fail',
        },
      ]
    },
    tableColumns() {
      if (this.editStatus === true) {
        return [
          { key: '_id', label: '#', sortable: false },
          { key: 'image', label: this.$t('Image'), sortable: false },
          { key: 'product', label: this.$t('Product name'), sortable: false },
          { key: 'option', label: this.$t('Option'), sortable: false },
          { key: 'price', label: this.$t('Price'), sortable: false },
          { key: 'amount', label: this.$t('Amount'), sortable: false },
          { key: 'action', label: this.$t('Action'), sortable: false },
          { key: 'total', label: this.$t('Total'), sortable: false },
        ]
      }
      return [
        { key: '_id', label: '#', sortable: false },
        { key: 'image', label: this.$t('Image'), sortable: false },
        { key: 'product', label: this.$t('Product name'), sortable: false },
        { key: 'option', label: this.$t('Option'), sortable: false },
        { key: 'price', label: this.$t('Price'), sortable: false },
        { key: 'amount', label: this.$t('Amount'), sortable: false },
        { key: 'total', label: this.$t('Total'), sortable: false },
      ]
    },
    respDataCoupon() {
      return store.state[STORE_MODULE_NAME_COUPON].respData != null
        ? store.state[STORE_MODULE_NAME_COUPON].respData.data.map(e => ({
          _id: e._id,
          name: `${this.showFromCurrentLanguage(e.name)}`,
        }))
        : []
    },
    respDataBranch() {
      return store.state[STORE_MODULE_NAME_BRANCH].respData != null
        ? store.state[STORE_MODULE_NAME_BRANCH].respData.data.map(e => ({
          _id: e._id,
          name: `${this.showFromCurrentLanguage(e.name)}`,
        }))
        : []
    },
  },
  watch: {
    async dataResponse(val) {
      if (val) {
        await this.getCoupon()
        await this.getBranch()
        this.initData()
      }
    },
  },
  async created() {
    this.debouncedSearchProducts = debounce(this.searchProducts, 400)
    await this.getCoupon()
    await this.getBranch()
    this.initData()
  },
  methods: {
    openAddProductModal() {
      this.isAddProductModalActive = true
      this.searchProducts()
    },
    searchProducts() {
      this.productSearchLoading = true
      const obj = {
        currentPage: this.currentPageProductSearch,
        pageSize: this.perPageProductSearch,
        searchQuery: this.searchProductQuery,
      }
      store
        .dispatch(`${this.storeModuleName}/getProduct`, obj)
        .then(result => {
          this.searchProductList = (result.data && result.data.data) || []
          this.searchProductMax = (result.data && result.data.max) || 0
          this.searchProductList.forEach(p => {
            if (this.selectedQuantityMap[p._id] === undefined) {
              this.$set(this.selectedQuantityMap, p._id, 1)
            }
            if (p.productOptions && p.productOptions.length > 0 && !this.selectedOptionsMap[p._id]) {
              this.$set(this.selectedOptionsMap, p._id, p.productOptions[0])
            }
          })
          this.productSearchLoading = false
        })
        .catch(error => {
          this.productSearchLoading = false
          console.error('searchProducts error:', error)
        })
    },
    onSearchPageChange(page) {
      this.currentPageProductSearch = page
      this.searchProducts()
    },
    addProductToOrder(item) {
      const selectedOpt = this.selectedOptionsMap[item._id]
      const qty = parseInt(this.selectedQuantityMap[item._id]) || 1
      const newObj = {
        _id: 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5),
        product: {
          _id: item._id,
          images: item.images || [],
          name: item.name,
          nameTranslate: item.nameTranslate || [],
          optionNameTranslate: item.optionNameTranslate || 'single',
          price: item.price,
          discount: item.discount || 0,
        },
        productOptionId: selectedOpt ? [selectedOpt] : [],
        productOptionDetailId: selectedOpt ? selectedOpt._id : null,
        price: item.price,
        price_currency: item.price,
        discount: item.discount || 0,
        discount_currency: item.discount || 0,
        amount: qty,
        comment: '',
      }
      this.products.push(newObj)
      this.editStatus = true
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-right',
        props: {
          title: this.$t('Success'),
          icon: 'CheckIcon',
          variant: 'success',
          text: `${this.$t('Product added successfully')}: ${item.name}`,
        },
      })
    },
    async getBranch() {
      const obj = {
        currentPage: 1,
        pageSize: 0,
        searchQuery: '',
      }

      await store
        .dispatch(`${STORE_MODULE_NAME_BRANCH}/get`, obj)
        .then(result => {

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    async getCoupon() {
      const obj = {
        currentPage: 1,
        pageSize: 0,
        searchQuery: '',
      }

      await store
        .dispatch(`${STORE_MODULE_NAME_COUPON}/get`, obj)
        .then(result => {

          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
        })
        .catch(error => {
          console.log('fetchUsers Error : ', error)
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    initData() {
      this.$nextTick(async () => {
        this.dataId = this.dataResponse._id
        this.products = this.dataResponse.products
        this.address = this.dataResponse.address.address
        this.orderStatus = this.dataResponse.orderStatus
        await this.getCountry()

        if (this.dataResponse.address.countryId !== null) {
          this.countryId = this.dataResponse.address.countryId
          console.log('1')
          await this.getProvince(this.countryId)
          if (this.dataResponse.address.stateId !== null) {
            const { name } = this.dataResponse.address.stateId
            const locale = this.showFromCurrentLanguage(name).toString()
            this.stateId = {
              ...this.dataResponse.address.stateId,
              name: locale,
            }
            console.log('2')
            await this.getDistrict(this.stateId)
            if (this.dataResponse.address.cityId !== null) {
              const { name } = this.dataResponse.address.cityId
              const locale = this.showFromCurrentLanguage(name).toString()
              this.cityId = {
                ...this.dataResponse.address.cityId,
                name: locale,
              }
              console.log('3')
              await this.getSubDistrict(this.cityId)
              if (this.dataResponse.address.subCityId !== null) {
                const { name } = this.dataResponse.address.subCityId
                const locale = this.showFromCurrentLanguage(name).toString()
                this.subCityId = {
                  ...this.dataResponse.address.subCityId,
                  name: locale,
                }
              } else {
                this.subCityId = null
              }
            } else {
              this.cityId = null
              store.commit(`${this.storeModuleName}/UPDATE_SUBDISTRICT`, [])
            }
          } else {
            this.stateId = null
            store.commit(`${this.storeModuleName}/UPDATE_DISTRICT`, [])
          }
        } else {
          this.countryId = null
          store.commit(`${this.storeModuleName}/UPDATE_PROVINCE`, [])
        }
        if (this.dataResponse.coupon.couponId !== null) {
          const index = this.respDataCoupon.findIndex(e => e._id.toString() === this.dataResponse.coupon.couponId.toString())
          if (index > -1) {
            this.couponId = this.respDataCoupon[index]._id
          }
        } else {
          this.couponId = null
        }

        if (this.dataResponse.branch.branchId !== null) {
          const index = this.respDataBranch.findIndex(e => e._id.toString() === this.dataResponse.branch.branchId.toString())
          if (index > -1) {
            this.branchId = this.respDataBranch[index]._id
          }
        } else {
          this.branchId = null
        }

        this.tel = this.dataResponse.address.tel
        this.zipCode = this.dataResponse.address.zipCode
        if (this.dataResponse.priceShipment !== null) {
          this.priceShipment = this.dataResponse.priceShipment / 100
        }
      })
    },
    getCountry() {
      store
        .dispatch(`${this.storeModuleName}/getCountry`, {})
        // eslint-disable-next-line no-unused-vars
        .then(result => { })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    getProvince(item) {
      // this.stateId = null
      // this.cityId = null
      // this.subCityId = null
      // store.commit(`${this.storeModuleName}/UPDATE_PROVINCE`, [])
      // store.commit(`${this.storeModuleName}/UPDATE_DISTRICT`, [])
      // store.commit(`${this.storeModuleName}/UPDATE_SUBDISTRICT`, [])
      if (item.id) {
        store
          .dispatch(`${this.storeModuleName}/getProvince`, { countryId: item.id })
          // eslint-disable-next-line no-unused-vars
          .then(result => { })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            // console.log('fetchUsers Error : ', error)
            // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
          })
      }
    },
    getDistrict(item) {
      // this.cityId = null
      // this.subCityId = null
      // store.commit(`${this.storeModuleName}/UPDATE_DISTRICT`, [])
      // store.commit(`${this.storeModuleName}/UPDATE_SUBDISTRICT`, [])
      if (item.id) {
        store
          .dispatch(`${this.storeModuleName}/getDistrict`, {
            countryId: this.countryId.id,
            provinceId: item.id,
          })
          // eslint-disable-next-line no-unused-vars
          .then(result => { })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            // console.log('fetchUsers Error : ', error)
            // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
          })
      }
    },
    getSubDistrict(item) {
      // this.subCityId = null
      // store.commit(`${this.storeModuleName}/UPDATE_SUBDISTRICT`, [])
      store
        .dispatch(`${this.storeModuleName}/getSubDistrict`, {
          countryId: this.countryId.id,
          provinceId: this.stateId.id,
          districtId: item.id,
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => { })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    totalProduct(product) {
      let price = 0
      if (this.dataResponse.currencyId === null) {
        price
          += product.price
          * parseFloat(product.amount.toString().replaceAll(',', ''))
      } else {
        price
          += product.price_currency
          * parseFloat(product.amount.toString().replaceAll(',', ''))
      }
      return (price / 100).toFixed(2)
    },
    deleteData(id) {
      this.$bvModal
        .msgBoxConfirm(`${this.$t('Do you want to delete')}?`, {
          title: this.$t('Please Confirm'),
          cancelVariant: 'outline-secondary',
          okVariant: 'danger',
          okTitle: this.$t('Yes'),
          cancelTitle: this.$t('No'),
          centered: true,
        })
        .then(value => {
          if (value === true) {
            const index = this.products.findIndex(
              e => e._id.toString() === id.toString(),
            )
            if (index > -1) {
              this.products.splice(index, 1)
            }
          }
          //  else {
          //   this.showToast(
          //     'warning',
          //     'top-right',
          //     `${this.$t('DELETE_CANCEL')}!`,
          //     'AlertCircleIcon',
          //     this.$t('DELETE_CANCEL'),
          //   )
          // }
        })
    },
    changeBranch(branchId) {
      store
        .dispatch(`${this.storeModuleName}/saveBranch`, {
          id: this.dataId,
          branchId,
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    changeCoupon(couponId) {
      store
        .dispatch(`${this.storeModuleName}/saveCoupon`, {
          id: this.dataId,
          couponId,
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    changeStatus(type) {
      store
        .dispatch(`${this.storeModuleName}/changeStatus`, {
          id: this.dataId,
          type,
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    saveOrder() {
      store
        .dispatch(`${this.storeModuleName}/saveOrder`, {
          id: this.dataId,
          products: this.products.map(e => ({
            ...e,
            amount: e.amount.toString().replaceAll(',', ''),
          })),
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    saveAddress() {
      store
        .dispatch(`${this.storeModuleName}/saveAddress`, {
          id: this.dataId,
          address: {
            address: this.address,
            tel: this.tel,
            countryId: this.countryId !== null ? this.countryId._id : null,
            stateId: this.stateId !== null ? this.stateId._id : null,
            cityId: this.cityId !== null ? this.cityId._id : null,
            subCityId: this.subCityId !== null ? this.subCityId._id : null,
          },
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    saveShippingPrice() {
      store
        .dispatch(`${this.storeModuleName}/saveShippingPrice`, {
          id: this.dataId,
          priceShipment: parseFloat(this.priceShipment.toString().replaceAll(',', '')),
        })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.$emit('update:data-response', result.data.data)
          // this.dataResponse = result.data.data

          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    sendOrderToWhatsapp() {
      const payload = {
        orderId: this.dataId,
        phoneNumber: this.tel || (this.dataResponse && this.dataResponse.address && this.dataResponse.address.tel) || '',
      }
      store
        .dispatch(`${this.storeModuleName}/sendToWhatsapp`, payload)
        .then(result => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Success'),
              icon: 'SuccessIcon',
              variant: 'success',
              text: this.$t(result.data.message || 'Sent to WhatsApp'),
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Failed to send to WhatsApp'),
            },
          })
        })
    },
    nameOption(data) {
      let name = ''
      for (let index = 0; index < data.length; index += 1) {
        name = name.toString() + (index === 0 ? '' : ',') + data[index].name
      }
      return name
    },
    subStringOrderId(data) {
      return data.substr(16, data.length)
    },
    showFromCurrentLanguage(data) {
      const indexLang = data.findIndex(e => e.lang === this.$i18n.locale)
      if (indexLang > -1) {
        return data[indexLang].value
      }
      return ''
    },
    /**
     * Opens chat with the member and sends initial order information message
     * Navigates to the chat page with the user ID and prepares order context
     */
        openChatWithMember() {
          const targetUserId = (this.dataResponse && (this.dataResponse.userId || (this.dataResponse.userInfo && (this.dataResponse.userInfo.userId || this.dataResponse.userInfo._id)))) || null
          if (targetUserId) {
            // Open chat page in new tab with the user ID and type parameter
            const chatUrl = `/e-commerce/chat?type=userId&userId=${targetUserId}`
            window.open(chatUrl, '_blank')
            
            // Get the firstname from userInfo
            const firstname = (this.dataResponse.userInfo && (this.dataResponse.userInfo.firstName || this.dataResponse.userInfo.firstname)) || ''
            
            // Store order information in localStorage for chat context
            const orderContext = {
              orderId: this.dataResponse._id,
              orderCode: this.dataResponse.orderCode,
              orderStatus: this.dataResponse.orderStatus,
              totalAmount: this.dataResponse.sale,
              currencySymbol: this.dataResponse.currencySymbol,
              timestamp: new Date().toISOString(),
              firstName: firstname
            }
            localStorage.setItem('chatOrderContext', JSON.stringify(orderContext))
            
            // Show success message
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: this.$t('Success'),
                icon: 'SuccessIcon',
                variant: 'success',
                text: this.$t('Redirecting to chat with order context'),
              },
            })
          } else {
            // Show error if user info is not available
            this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                title: this.$t('Error'),
                icon: 'ErrorIcon',
                variant: 'danger',
                text: this.$t('User information not available for chat'),
              },
            })
          }
        },
  },
}
</script>
